import Mapping from './mapping'
import { IAnyModelType, types as t } from '@invisr/mobx-state-tree'
import crudActions from './crud-actions'
import { FieldBase as Field } from './field'

export default t
  .model('WhereRule', {
    ruleNumber: t.number,
    leftField: t.maybeNull(Field),
    fieldType: t.maybeNull(t.string),
    rightValue: t.maybeNull(t.late((): IAnyModelType => Mapping)),
    operator: t.maybeNull(t.string)
  })
  .views(self => {
    return {
      get isValid () {
        return self.leftField && self.rightValue && self.operator
      },
      get currentValue () {
        if (self.rightValue.value) return self.rightValue.value
        return ''
      }
    }
  })
  .actions(crudActions)
  .preProcessSnapshot(snap => {
    if (snap.leftField && typeof snap.leftField !== 'object') {
      snap.leftField = {
        fieldPath: snap.leftField,
        label: snap.leftField
      }
      if (snap.fieldType) snap.leftField.type = snap.fieldType
    }
    return snap
  })
